import React from 'react';

class Category extends React.Component {
    render() {
        const catalogs = this.props.catalogs;
        const category = this.props.category;
        const save = this.props.save;
        const siteCode = this.props.siteCode;

        const isAll = this.props.isAll;
        const applyAll = this.props.applyAll;

        return(
            <div className={"prodType-group "+category}>
                <h3>{category}</h3>
                <div className={category+"-catalogs"}>
                    <div className="group-labels">
                        <label>Active</label>
                        <label>Manufacturer</label>
                        <label>Brand</label>
                        <label>Dealer Brand</label>
                    </div>
                    {(category === "rugs") && (
                        <div className="all-rugs input-row">
                            <div>
                                <input type="checkbox" id={"all-rugs"} checked={isAll("rugs")} onChange={() => applyAll("rugs", isAll("rugs"))} />
                            </div>
                            <label>All Rugs</label>
                            <label>All</label>
                            <label>All</label>
                        </div>
                    )}
                    {catalogs.map((catalog, index) =>
                        ((category === "rugs" && isAll("rugs") === false) || (category !== "rugs") ) && (
                            <div className="input-row" key={index}>
                                <div>
                                    <input
                                        type="checkbox"
                                        defaultChecked={ catalog.active }
                                        onClick={() => save(
                                            catalog.productType,
                                            catalog.manufacturer,
                                            catalog.brand,
                                            catalog.dealerBrand,
                                            catalog.id,
                                            siteCode,
                                            catalog.active
                                        )}
                                    />
                                </div>
                                <label>{catalog.manufacturer}</label>
                                <label>{catalog.brand}</label>
                                <label>{catalog.dealerBrand}</label>
                            </div>
                        )
                    )}
                </div>
            </div>
        )
    }
}
export default Category;


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/CatalogCategory.js